import React from 'react';

import { Message } from 'src/core/components';
import messages from './messages';

export const selectFilesData = (state) => {
  const filesState = state.files || {};

  const files = Object.keys(filesState)
    .map((key) => {
      const file = { ...filesState[key] };

      if (file.error) {
        file.error = <Message message={messages.failed} />;
      }

      return file;
    });

  return files || [];
};
